// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"923":"cf93db37b5265132","7450":"9a10c6254339fb57"}[chunkId] + ".css";
};